import { cms as cmsApi } from '../../../api';
import { useApi, useInternationalization } from '../../../hooks';
import { PublicationFilter, ContentStatus } from '../../../types';
import { MIN_PAGINATION_FILTER } from '../../../constants';
import { NewspaperRounded } from '@mui/icons-material';
import { routes } from '../../../routes';
import { CounterWidget } from './CounterWidget';
import { WidgetProps } from './Widget';

const filter: PublicationFilter = {
  status: ContentStatus.Submitted,
  ...MIN_PAGINATION_FILTER,
};

export const SubmittedPublications = (props: WidgetProps) => {
  const { t } = useInternationalization();
  const { data, isLoading } = useApi(cmsApi.getAllPublications, null, filter);

  return (
    <CounterWidget
      {...props}
      isLoading={isLoading}
      count={data?.totalCount}
      title={t('dashboard:submittedPublications:title')}
      icon={NewspaperRounded}
      link={routes.Admin.Cms.Publications.path}
    />
  );
};
